<template>
	<div>
		<div class="d-flex justify-content-center py-4" v-if="isLoading">
			<loader/>
		</div>
		<notification-message
			message="Parece que aún no agregas testimonios"
			v-if="testimonials=='' && !isLoading"
		/>
    <div class="main-content-container container-fluid px-4"> 

      <div class="page-header row no-gutters py-4" v-if="!isLoading">
        <div class="col-12 col-sm-6 text-center text-sm-left mb-4 mb-sm-0">
          <span class="text-uppercase page-subtitle">Visión general</span>
          <h3 class="page-title">Testimonios</h3>
        </div>
        <div class="col-12 col-sm-6 d-flex align-items-center">
          <div class="d-none d-md-inline-flex mb-sm-0 mx-auto ml-sm-auto mr-sm-0" role="group" aria-label="Page actions">
            <router-link to="agregar/testimonio" id="add-new-event" class="btn btn-primary">
              <i class="fas fa-plus"></i> 
              Testimonio 
            </router-link>
          </div>
        </div>
      </div>

			<div class="row">
			  <div class="col-lg-4" v-for="(item, index) of testimonials">
			    <router-link to="/" class="no-hover">
			      <div class="card card-small mb-4 pt-3">
			        <div class="card-body border-bottom text-center">
			          <div class="mb-3 mx-auto">
			            <img class="img-fluid" :src="item.photo">
			          </div>
			          <h4 class="mb-0">{{ item.name }} {{ item.lastname }}</h4>
			        </div>
			        <div class="card-footer text-muted">
			        	{{ item.message }}
			        </div>
							<div class="card-footer border-top text-primary">
								<span class="badge badge-secondary mr-2" @click.prevent="deleteOption(item.id, index)">
									<i class="fas fa-trash"/>
								</span>
								<router-link :to="'testimonio/' + item.slug" class="badge badge-secondary"><i class="fas fa-edit"></i></router-link>
							</div>
			      </div>
			    </router-link>
			  </div>
			</div>
    	</div>
	</div>
</template>

<script>
	import NotificationMessage from '@/components/general/NotificationMessage';
	export default {
		components: {
			NotificationMessage
		},
		
		data() {
			return {
				isLoading: true,
				testimonials: [],
			}
		},

		mounted() {
			this.getTestimonials();
		},

		methods: {
			async getTestimonials() {
				let response = await fetch(`${process.env.VUE_APP_ROOT_API}/testimonial`);
				if(response.status == 200) {
					this.isLoading = false;
					this.testimonials = await response.json();
				}
			},

			deleteOption(id, index) {
				const message = '¿Quieres eliminar este testimonio?';
				const options = {
					okText: 'Sí',
					cancelText: 'No'
				};
				let that = this;
				this.$dialog
					.confirm(message, options)
					.then(function(dialog) {
						that.deleteTestimonial(id, index);
					});
			},

			async deleteTestimonial(id, index) {
				const url = `${process.env.VUE_APP_ROOT_API}/testimonial/${id}`;

				const settings = {
					method: 'DELETE',
				};

				const response = await fetch(url, settings);
				switch (response.status) {
					case 200:
						this.testimonials.splice(index, 1);
					break;
				}
			}
		}
	}
</script>